import {config} from '../config';

export default {
    getIsMarketInitialized: () => config.data.isMarketInitialized,
    getIsMarketDetected: () => config.data.isMarketDetected,
};
